import { ICourse, ICourse2 } from '@et/types/Courses'
import { GATSBYIMGLOADING } from '@et/types/Enums'
import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { useVideoStats } from '@hooks/useVideoStats'
import { classNames, renderSvg } from '@utils/genUtils'
import { GatsbyImage } from 'gatsby-plugin-image'
import { svgs } from '@svg'
import React from 'react'
import CtaButtonTw from '@components/buttons/ctaButtonTw'

interface Props {
  image1?: IGatsbyImageDataObject
  convert?: boolean
  buttonText?: string
  showMonthCard?: boolean
}

function PatternClassCard(props: ICourse2 & Props) {
  const { curriculum, image1, tagline, courseCard, price, salePrice, onSale, convert = false, sellCard, buttonText, paymentPlan, showMonthCard = true } = props
  const { totalModules, totalVideos, totalMins } = useVideoStats(curriculum)
  const items = [
    totalModules,
    totalVideos,
    totalMins
  ]

  return (
    <div
      className='py-12 et-grid-basic xl:pt-16 bg-cream-200'>

      <div className='col-span-2 col-start-2 mb-8 md:col-start-2 md:col-span-12 lg:col-start-2 lg:col-span-8 lg:mb-0 xl:col-start-2 xl:col-span-8'>

        <h2 className='font-medium md:text-xl'>Floral Patterns in Procreate</h2>
        <h3 className='text-4xl font-sentinel__SemiBoldItal md:text-5xl xxl:text-6xl'>
          {convert ? 'Get the Ultimate Procreate Pattern Course' : 'Unlock these features with your enrollment'}
        </h3>

      </div>

      {/* IMAGE 1 */}
      {/* <div className={classNames('relative col-span-2 col-start-2 mb-8 md:row-start-2 md:col-start-2 md:col-span-6 md:mb-0 lg:col-start-2 lg:col-span-6 lg:max-h-[339px]', onSale ? '' : '')}>
        
      </div> */}

      {/* PRICE CARD */}
      <div className={classNames('col-span-2 col-start-2 mb-8 md:row-start-2 md:mb-0 flex flex-col md:flex-row lg:max-h-[339px] md:col-span-full md:max-w-[1200px] md:mx-auto md:w-full gap-x-8 gap-y-8 lg:px-7 xl:px-0')}>

        {image1 && <div className='relative w-full overflow-hidden rounded-2xl md:h-full md:w-0 lg:w-full'>
          <GatsbyImage className='md:h-full' image={image1.gatsbyImageData} alt={'Teela making Patterns in Procreate in her studio'} loading={GATSBYIMGLOADING.LAZY} />
        </div>}

        <div className='CARD bg-[#E9D0BA] rounded-2xl p-6 flex flex-col w-full md:max-w-[278px] justify-between'>
          <h4 className={classNames(onSale ? '' : '', 'flex-1 text-4xl font-sentinel__SemiBoldItal mb-16 xl:mb-0')}>One Time Purchase</h4>

          {onSale && <h5 className='text-xs font-semibold uppercase'>Limited Time Offer</h5>}

          <div className='flex flex-row items-center my-4 mt-2 text-5xl gap-x-5 font-sentinel__SemiBoldItal '>
            <div className={classNames('relative')}>
              {onSale && <span className={classNames('z-2 absolute top-1/2 -rotate-12 -translate-y-1/2 left-1/2 -translate-x-1/2 w-[130%] h-1 bg-[#A19183]')} />}
              <span className={classNames('relative z-1', onSale ? 'text-[#A19183]' : '')}>
                ${price}
              </span>
            </div>
            {onSale && <div className='text-5xl text-rusted-900'>${salePrice}</div>}
          </div>

          {convert && <a href={onSale ? sellCard.saleLink : sellCard.link}
            className={classNames('btn-lg w-full mx-auto bg-rusted-900 !text-white border-rusted-900 flex-1 btn focus:outline-none md:flex-none')}>
            {buttonText ? buttonText : 'Let\'s do this!'}
          </a>}
          {!convert && <CtaButtonTw
            id={'checkout-card'}
            className={'btn-lg w-full mx-auto bg-rusted-900 text-white border-rusted-900 flex-1'}
            text={buttonText ? buttonText : 'Enroll Now!'} />}

        </div>


        {/* MONTHLY PAYMENTS */}
        {showMonthCard && <div className='CARD bg-[#e8e1da] rounded-2xl p-6 flex flex-col w-full md:max-w-[278px] justify-between'>
          <h4 className={classNames(onSale ? '' : '', 'flex-1 text-4xl font-sentinel__SemiBoldItal mb-16 xl:mb-0')}>3 Monthly Payments </h4>

          {onSale && <h5 className='text-xs font-semibold uppercase'>Limited Time Offer</h5>}

          <div className='flex flex-row items-center my-4 mt-2 text-5xl gap-x-5 font-sentinel__SemiBoldItal '>
            <div className={classNames('relative flex flex-row')}>
              {onSale && <span className={classNames('z-2 absolute top-1/2 -rotate-12 -translate-y-1/2 left-1/2 -translate-x-1/2 w-[130%] h-1 bg-[#A19183]')} />}
              <span className={classNames('relative z-1', onSale ? 'text-[#A19183]' : '')}>
                ${paymentPlan.price}
              </span>
              <span className='flex flex-col mt-2 ml-2 text-sm'>
                <span className='leading-none'>per</span>
                <span className='leading-none'>month</span>
              </span>
            </div>
            {onSale && paymentPlan.salePrice && <div className='text-5xl text-rusted-900'>${paymentPlan.salePrice}</div>}
          </div>

          {convert && <a href={onSale ? sellCard.saleLink : sellCard.paymentPlanLink}
            className={classNames('btn-lg w-full mx-auto bg-[#3a322d] !text-white border-[#3a322d] flex-1 btn focus:outline-none md:flex-none')}>
            {buttonText ? buttonText : 'Let\'s do this!'}
          </a>}
          {!convert && <CtaButtonTw
            id={'checkout-card'}
            className={'btn-lg w-full mx-auto bg-rusted-900 text-white border-rusted-900 flex-1'}
            text={buttonText ? buttonText : 'Enroll Now!'} />}

        </div>}


        {/* ORIGINAL CARD FOR REF    */}
        {/* <div className='CARD bg-[#E9D0BA] rounded-2xl p-6 flex flex-col md:max-w-[300px]'>
          <h4 className={classNames(onSale ? 'mb-16' : 'mb-20', 'text-4xl font-sentinel__SemiBoldItal md:pr-28 lg:pr-20')}>One Time Purchase</h4>

          {onSale && <h5 className='text-xs font-semibold uppercase'>Limited Time Offer</h5>}

          <div className='flex flex-row items-center flex-1 my-4 mt-2 text-5xl gap-x-5 font-sentinel__SemiBoldItal md:ml-4'>
            <div className={classNames('relative')}>
              {onSale && <span className={classNames('z-2 absolute top-1/2 -rotate-12 -translate-y-1/2 left-1/2 -translate-x-1/2 w-[130%] h-1 bg-[#A19183]')} />}
              <span className={classNames('relative z-1', onSale ? 'text-[#A19183]' : '')}>
                ${price}
              </span>
            </div>
            {onSale && <div className='text-5xl text-rusted-900'>${salePrice}</div>}
          </div>

          {convert && <a href={onSale ? sellCard.saleLink : sellCard.link}
            className={classNames('btn-lg w-full mx-auto bg-rusted-900 !text-white border-rusted-900 flex-1 btn focus:outline-none')}>
            {buttonText ? buttonText : 'Let\'s do this!'}
          </a>}
          {!convert && <CtaButtonTw
            id={'checkout-card'}
            className={'btn-lg w-full mx-auto bg-rusted-900 text-white border-rusted-900 flex-1'}
            text={buttonText ? buttonText : 'Enroll Now!'} />}

        </div> */}

        <div className='flex-col flex-wrap justify-between hidden md:flex md:ml-[-10px] STATS md:pb-8 lg:py-6 lg:ml-0'>

          {items.map((item, index) => {
            const type = index === 0
              ? 'Modules'
              : index === 1
                ? 'Videos'
                : 'hours'


            const count = index === 0
              ? item
              : index === 1
                ? item
                : '4+'
            return (
              <div key={index} className='flex flex-col'>
                <span className='text-5xl font-sentinel__SemiBoldItal'>{count}</span>
                <span className='text-2xl leading-none'>{type}</span>
              </div>
            )
          })}

        </div>

      </div>


      {/* BULLETS */}
      <div className='col-span-2 col-start-2 md:col-start-2 md:col-span-12 lg:mt-4'>
        <h2 className='mb-2 text-xl font-bold'>Enrollment includes:</h2>

        <div className='grid pt-6 border-t-4 md:grid-cols-2 border-grey-600 lg:grid-cols-3 xl:pt-12'>

          {courseCard.bullets.map((bullet, index) => {
            const isLastItem = index === courseCard.bullets.length - 1
            return (
              <div key={index} className='flex flex-row items-start py-1 mb-3 text-lg md:border-b-[1px] border-[#b3b3b3] md:pb-4 md:pt-2 md:pr-8 md:last:col-span-full lg:pr-4 xl:pr-6 last:border-b-0'>
                <span className='w-4 mt-1.5 mr-2'>
                  {renderSvg(svgs.Checkmark)}
                </span>
                <span className={classNames(isLastItem ? 'md:w-1/2 md:pr-10 lg:w-[33.33%]' : 'flex-1', '')}>
                  {bullet}
                </span>
              </div>
            )
          })}

        </div>

      </div>
    </div>
  )
}

export default PatternClassCard
